import React from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { LabelGroup, OptionRow, OptionWrapper } from './index.style';

const GroupOption = ({
  useForeignVoice = true,
  useVoiceClone = true,
  onChangeOption,
}) => {
  const { t } = useTranslation();

  const handleForeignVoiceChange = (event) => {
    if (onChangeOption) {
      onChangeOption('useForeignVoice', event.target.checked);
    }
  };

  const handleVoiceCloneChange = (event) => {
    if (onChangeOption) {
      onChangeOption('useVoiceClone', event.target.checked);
    }
  };

  return (
    <OptionWrapper>
      <OptionRow>
        <FormControlLabel
          control={
            <Checkbox
              checked={useForeignVoice}
              onChange={handleForeignVoiceChange}
              sx={{
                color: COLOR.darkBlue,
                '&.Mui-checked': {
                  color: COLOR.darkBlue,
                },
                padding: '2px',
                marginLeft: '6px',
              }}
            />
          }
          label={
            <Typography
              className="group-option-title"
              variant="body-16-medium"
              color={COLOR.darkGray}
            >
              {t('foreignVoice')}
            </Typography>
          }
          sx={{
            margin: 0,
            flexDirection: 'row-reverse',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center',
          }}
        />
      </OptionRow>
      <OptionRow sx={{ alignItems: 'flex-start' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={useVoiceClone}
              onChange={handleVoiceCloneChange}
              sx={{
                color: COLOR.darkBlue,
                '&.Mui-checked': {
                  color: COLOR.darkBlue,
                },
                padding: '2px',
                marginLeft: '6px',
                '@media (max-width: 768px)': {
                  alignSelf: 'center',
                },
              }}
            />
          }
          label={
            <LabelGroup>
              <Typography
                className="group-option-title"
                variant="body-16-medium"
                color={COLOR.darkGray}
              >
                {t('createVoiceFromOwnVoice')}
              </Typography>
              <Typography
                className="group-option-description"
                variant="body-14-regular"
                color={COLOR.descriptionUpload}
              >
                {t('professionalAIVoiceClone')}
              </Typography>
            </LabelGroup>
          }
          sx={{
            margin: 0,
            flexDirection: 'row-reverse',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'flex-start',
            '& .MuiFormControlLabel-label': {
              flex: 1,
            },
          }}
        />
      </OptionRow>
    </OptionWrapper>
  );
};

export default GroupOption;
